// extracted by mini-css-extract-plugin
export default {"description":"X0_La"};